export default __webpack_public_path__ + "static/media/orderOnProgress.4924fc97.svg";